/**
 * Calculator form section with loading states and error handling
 */
import { Paper, Title, Stack, Alert, Skeleton } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { CalculatorForm } from './TariffCalculator';
import type { OSDCode as OSDMetaCode } from '../../../utils/osdMetadata';
import type { CalculatorFormValues } from '../types/calculator.types';

interface CalculatorFormSectionProps {
  onSubmit: (values: CalculatorFormValues) => void;
  loading: boolean;
  error: string | null;
  onErrorClose: () => void;
  initialValues?: CalculatorFormValues;
  selectedOSD: OSDMetaCode;
  calculationYear: number;
}

export function CalculatorFormSection({
  onSubmit,
  loading,
  error,
  onErrorClose,
  initialValues,
  selectedOSD,
  calculationYear,
}: CalculatorFormSectionProps) {
  return (
    <Stack gap="md">
      {/* Calculator Form */}
      <Paper p="xl" shadow="sm" withBorder>
        <Title order={2} mb="lg">
          Podaj swoje dane
        </Title>
        <CalculatorForm
          onSubmit={onSubmit}
          loading={loading}
          initialValues={initialValues}
          selectedOSD={selectedOSD}
          calculationYear={calculationYear}
        />
      </Paper>

      {/* Loading Skeleton */}
      {loading && (
        <Stack gap="md">
          <Skeleton height={50} />
          <Skeleton height={50} />
          <Skeleton height={300} />
        </Stack>
      )}

      {/* Error Alert */}
      {error && (
        <Alert
          icon={<IconAlertCircle size={20} />}
          title="Błąd"
          color="red"
          variant="filled"
          onClose={onErrorClose}
          withCloseButton
        >
          {error}
        </Alert>
      )}
    </Stack>
  );
}
